// ============================================================================
// CANCUN100 — puenteB2B.js  (APP 2/07 · S3: puente producción → B2B a través de la Edge Function `puente-b2b`)
// ----------------------------------------------------------------------------
// Reemplaza a b2bClient.js. El navegador ya NO conoce la URL, la anon key ni el usuario/contraseña del B2B:
// todo vive como secretos de la función. Aquí solo se llama `supabase.functions.invoke('puente-b2b')` con la
// sesión de Auth del usuario (admin o agente activo); la función valida quién llama y la acción (lista cerrada).
// Acciones: 'estado' · 'crear_cotizacion' · 'reserva_xp_preparar' · 'reserva_xp_enviar'.
// ============================================================================
import { supabase } from './supabaseClient';

// Identidad del puente en el B2B (agencia "Cancun100 Interna"): solo un id público, no una credencial.
export const AGENCIA_PUENTE_ID = '4570a4ad-6063-4f6c-9ad4-bf0781dbe309';

// ¿Hay sesión de Auth con la que firmar la llamada? (sin ella la función responde 401)
export const puenteDisponible = async () => {
  try { const { data } = await supabase.auth.getSession(); return !!data?.session; } catch { return false; }
};

// Llama una acción del puente. Devuelve `data` o lanza un Error con mensaje claro.
export const puenteB2B = async (accion, params = {}) => {
  const { data, error } = await supabase.functions.invoke('puente-b2b', { body: { accion, ...params } });
  if (error) {
    // supabase-js envuelve el 4xx/5xx; el cuerpo trae { ok:false, error, mensaje }.
    let det = null;
    try { det = error.context && typeof error.context.json === 'function' ? await error.context.json() : null; } catch { det = null; }
    throw new Error((det && det.mensaje) || error.message || 'El puente B2B no respondió.');
  }
  if (!data || data.ok === false) throw new Error((data && data.mensaje) || 'El puente B2B devolvió un error.');
  return data.data;
};
